import { Button, Card, Col, Input, message, Pagination, Row, Spin, Tabs } from "antd";
import React, { useEffect, useState } from "react";

import CreateInsuranceModal from "./CreateInsuranceModal";
import InsuranceContainer from "./InsuranceContainer";
import InsuranceFilters from "./InsuranceFilters";
import InsuranceLabel from "./InsuranceLabel";

import taskSquareWhite from "../../assets/icons/task-square-white.svg";
import search from "../../assets/icons/search-normal.png";
import archive from "../../assets/icons/archive3.svg";
import filter from "../../assets/icons/filter.svg";

import { controller as treatmentsController } from "../TreatmentPlans/controller";
import { controller } from "../../controller";

export default function InsuranceMainPage({ setSelectedInsurance, predeterminationOrPostPayment, setPredeterminationOrPostPayment }) {
  const [activeTab, setActiveTab] = useState("");
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [isGettingPatients, setIsGettingPatients] = useState(false);
  const [isGettingProcedures, setIsGettingProcedures] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [allPatients, setAllPatients] = useState([]);
  const [allProcedures, setAllProcedures] = useState([]);
  const [insuranceStatus, setInsuranceStatus] = useState({ pending: "", approved: "" });
  const [mySearch, setMySearch] = useState(null);
  const [filters, setFilters] = useState({ from: undefined, to: undefined, patient_ids: undefined, procedure_ids: undefined });
  const [insuranceTypeForClassName, setInsuranceTypeForClassName] = useState(predeterminationOrPostPayment);
  const [isGettingInsurances, setIsGettingInsurances] = useState(false);
  const [insurancesData, setInsurancesData] = useState([]);
  const [count, setCount] = useState(0);

  const children =
    isGettingInsurances || isGettingPatients || isGettingProcedures ? (
      <Spin />
    ) : (
      <InsuranceContainer filters={filters} insurances={insurancesData} setSelectedInsurance={setSelectedInsurance} />
    );

  const insuranceTabs = [
    { key: "", label: <p style={{ fontSize: 16 }}>All</p>, children },
    { key: "accepted", label: <p style={{ fontSize: 16 }}>Approved</p>, children },
    { key: "pending", label: <p style={{ fontSize: 16 }}>Pending</p>, children },
    { key: "processing", label: <p style={{ fontSize: 16 }}>Processing</p>, children },
  ];

  useEffect(
    function () {
      if (!showRequestModal) handleUpdateData();
    },
    [showRequestModal]
  );

  useEffect(() => {
    handleUpdateData();
  }, [currentPage, activeTab, filters, predeterminationOrPostPayment]);

  useEffect(() => {
    setFilters({ ...filters, search: mySearch });
  }, [mySearch]);

  useEffect(() => {
    getinsuranceStatus();
  }, []);

  // Getting all office patients
  useEffect(function () {
    async function getAllOfficePatients() {
      try {
        setIsGettingPatients(true);
        const res = await controller.getPatient2();
        setAllPatients(res);
      } catch (err) {
        message.error("Something went wrong while fetching all patients");
        console.log(err);
      } finally {
        setIsGettingPatients(false);
      }
    }
    getAllOfficePatients();
  }, []);

  // Getting all procedures
  useEffect(function () {
    async function getAllProcedures() {
      try {
        setIsGettingProcedures(true);
        const res = await treatmentsController.getProcedure(0, "");
        setAllProcedures(res.json);
      } catch (err) {
        message.error("Something went wrong while fetching procedures");
        console.error(err);
      } finally {
        setIsGettingProcedures(false);
      }
    }
    getAllProcedures();
  }, []);

  async function handleUpdateData() {
    try {
      setIsGettingInsurances(true);
      setInsurancesData([]);

      const data = await controller.getInsurances(currentPage, activeTab, filters, predeterminationOrPostPayment);

      setCount(data.json.count);
      setInsurancesData(data.json.results);
    } catch (err) {
      message.error("Something went wrong while getting insurances");
      console.log(err);
      // setIsGettingInsurances(false);
    } finally {
      setIsGettingInsurances(false);
    }
  }

  async function getinsuranceStatus() {
    const response = await controller.getInsuranceApprovedReceived();
    setInsuranceStatus(response.json);
  }

  function handleSwitchPredeterminationPostPayment(type) {
    setInsurancesData([]);
    setInsuranceTypeForClassName(type);
    setIsGettingInsurances(true);
    setPredeterminationOrPostPayment(type);
    setCurrentPage(1);
  }

  return (
    <div style={{ padding: "20px 30px" }}>
      <div style={{ fontSize: 20, fontWeight: "600", color: "black", marginBottom: 40, marginTop: 52 }}>Predetermination and Post Payment</div>

      <Card style={{ width: "100%" }}>
        <Row gutter={[16, 16]} justify="space-around">
          <InsuranceLabel icon={archive} data={`${insuranceStatus.pending}`} label="Pending" />
          <InsuranceLabel icon={taskSquareWhite} data={`${insuranceStatus.approved}`} label="Approved" />

          <Col xs={24} sm={24} md={24} lg={8}>
            <Input
              value={mySearch}
              onChange={(e) => {
                setMySearch(e.target.value);
              }}
              size="large"
              placeholder="Search Insurance"
              suffix={<img src={search} alt="" />}
              style={{ width: "100%", marginBottom: "16px", height: 52 }}
              className="centered-placeholder"
            />
            <Button type="primary" size="large" block style={{ height: 52 }} onClick={() => setShowRequestModal(true)}>
              New Request
            </Button>
          </Col>
        </Row>
      </Card>

      {/* Predetermination and Post Payment tabs */}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 30,
        }}
      >
        <div
          style={{
            borderRadius: 100,
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
            padding: "7px",
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <Button
            className={`post-payment-predetermination-tabs ${insuranceTypeForClassName === "predetermination" ? "active" : ""} `}
            onClick={() => handleSwitchPredeterminationPostPayment("predetermination")}
            style={{ cursor: isGettingInsurances ? "not-allowed" : "pointer" }}
            disabled={isGettingInsurances}
          >
            Predetermination
          </Button>
          <Button
            className={`post-payment-predetermination-tabs ${insuranceTypeForClassName === "post_payment" ? "active" : ""} `}
            onClick={() => handleSwitchPredeterminationPostPayment("post_payment")}
            style={{ cursor: isGettingInsurances ? "not-allowed" : "pointer" }}
            disabled={isGettingInsurances}
          >
            Post Payment
          </Button>
        </div>
      </div>

      <Card style={{ marginTop: 30, padding: "0 10px", position: "relative" }}>
        {/* Filters */}
        {showFilters && <InsuranceFilters filters={filters} setFilters={setFilters} allPatients={allPatients} allProcedures={allProcedures} />}

        <Tabs
          defaultActiveKey="all"
          items={insuranceTabs}
          onChange={(key) => {
            setCurrentPage(1);
            setActiveTab(key);
          }}
          size={20}
        />

        <Row justify={"center"}>
          <Pagination
            current={currentPage}
            total={count}
            showSizeChanger={false}
            onChange={(e) => {
              setCurrentPage(e);
            }}
          />
        </Row>

        <Button
          style={{ border: "none", position: "absolute", right: 20, top: 20, height: 40, width: 40 }}
          onClick={() => setShowFilters((show) => !show)}
        >
          <img src={filter} alt="filter" style={{ height: 25, width: 25 }} />
        </Button>
      </Card>

      {/* Requet Modal */}
      <CreateInsuranceModal showRequestModal={showRequestModal} setShowRequestModal={setShowRequestModal} />
    </div>
  );
}
